var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStack = function SvgStack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 57",
    width: 60,
    height: 57
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.3333335 0 0 3.3333335 -0 0.16666731)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7528 4.87498L9.49742 1.12224C 9.34188 1.04192 9.16937 1 8.99431 1C 8.81925 1 8.64674 1.04192 8.4912 1.12224L8.4912 1.12224L1.23727 4.87498C 1.16582 4.9117 1.10587 4.96741 1.06401 5.03598C 1.02215 5.10456 1 5.18334 1 5.26368C 1 5.34402 1.02215 5.42281 1.06401 5.49138C 1.10587 5.55996 1.16582 5.61567 1.23727 5.65239L1.23727 5.65239L8.49191 9.40513C 8.64745 9.48545 8.81996 9.52737 8.99502 9.52737C 9.17008 9.52737 9.34259 9.48545 9.49813 9.40513L9.49813 9.40513L16.7528 5.65239C 16.824 5.61549 16.8838 5.55972 16.9254 5.49117C 16.9671 5.42261 16.9892 5.34392 16.9892 5.26368C 16.9892 5.18345 16.9671 5.10475 16.9254 5.0362C 16.8838 4.96765 16.824 4.91188 16.7528 4.87498z",
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinecap: "square",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.01123 8.99219L8.49184 12.6007C 8.64738 12.681 8.81989 12.7229 8.99495 12.7229C 9.17001 12.7229 9.34252 12.681 9.49806 12.6007L9.49806 12.6007L17 8.99219",
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinecap: "square",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.01123 12.1953L8.49184 15.8038C 8.64738 15.8841 8.81989 15.926 8.99495 15.926C 9.17001 15.926 9.34252 15.8841 9.49806 15.8038L9.49806 15.8038L17 12.1953",
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinecap: "square",
    fill: "none"
  }))));
};
export default SvgStack;